export default __webpack_public_path__ + "static/media/appStore-ESP.00452d17.png";